document.addEventListener('DOMContentLoaded', function() {
    // Only proceed if the poster popup exists
    var popup = document.getElementById('frame-suggestion-popup');
    var closePopupButton = document.querySelector('.close-popup');

    // Function to handle Add to Cart event
    function handleAddToCart(e, addToCartForm) {
        e.preventDefault(); // Prevent default form submission

        // Create FormData object for the AJAX request
        var formData = new FormData(addToCartForm);

        // Perform AJAX request to add item to cart
        fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then(function(response) {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json(); // Parse JSON response
        })
        .then(function(data) {
            console.log('Product added to cart:', data);
            // Show the popup only if it's a poster product and popup element exists
            if (popup) {
                popup.style.display = 'flex';
            }
        })
        .catch(function(error) {
            console.error('Error adding to cart:', error);
        });
    }

    // Only run this code for posters, which have the popup
    if (popup) {
        // Handle the Add to Cart button for the product page (button one)
        var addToCartButton = document.querySelector('#ProductSubmitButton-template--24964798185738__main');
        if (addToCartButton) {
            var addToCartForm = addToCartButton.closest('form');
            addToCartButton.addEventListener('click', function(e) {
                handleAddToCart(e, addToCartForm);
            });
        }

        // MutationObserver to detect button two when it becomes available
        var observer = new MutationObserver(function(mutationsList) {
            mutationsList.forEach(function(mutation) {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    var addToCartButtonTwo = document.querySelector('#ProductSubmitButton-quickadd-template--24964798185738__main');
                    if (addToCartButtonTwo) {
                        var addToCartFormTwo = addToCartButtonTwo.closest('form');
                        addToCartButtonTwo.addEventListener('click', function(e) {
                            handleAddToCart(e, addToCartFormTwo);
                        });
                        observer.disconnect(); // Stop observing after the button is found
                    }
                }
            });
        });

        // Start observing changes in the document
        observer.observe(document.body, { childList: true, subtree: true, attributes: true });

        // Handle the second quick add button (button three)
        var addToCartButtonthree = document.querySelector('#quick-add-template--19777850704138__product-grid9643556208906-submit');
        if (addToCartButtonthree) {
            var addToCartFormThree = addToCartButtonthree.closest('form');
            addToCartButtonthree.addEventListener('click', function(e) {
                handleAddToCart(e, addToCartFormThree);
            });
        }

        // Close popup and redirect to the cart page
        if (closePopupButton) {
            closePopupButton.addEventListener('click', function() {
                popup.style.display = 'none'; // Hide the popup
                window.location.href = '/cart'; // Redirect to cart page for all buttons
            });
        }
    }
});